import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import ButtonStrap from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';

import bsCustomFileInput from 'bs-custom-file-input';
const algoliasearch = require('algoliasearch');

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/storage');

export class EditSoftwarePage extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.isValidFileType = this.isValidFileType.bind(this);
    this.handleUploadPhotoToggle = this.handleUploadPhotoToggle.bind(this);
    // Firestore
    this.db = firebase.firestore();
    this.usersRef = this.db.collection('user_accounts');
    // Firebase storage
    this.storageRef = firebase.storage().ref();

    const client = algoliasearch(
      'E2SNSK2V24',
      '82fd6ee56c067f64d5fd8f63ab35b999'
    );
    this.index = client.initIndex('product_pages');

    this.state = {
      prodType: 'Software',
      prodName: '',
      prodCategory: '',
      prodPrice: 0,
      prodDevName: '',
      prodDetails: '',
      prodLink: '',
      createdByUser: 'tejassharma08@gmail.com',
      termsAgree: false,
      updatePhoto: false,
      pagesLeft: 2,
      pages: [],
      files: [],
      showAlert: false, // for handling alerts
      alertText: [],
    };
  }

  componentDidMount() {
    bsCustomFileInput.init();

    // TODO: THIS CAN BE USED TO REDIRECT IF NO USER IS LOGGED IN
    let _this = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.setState({ createdByUser: user.email });
        _this.db
          .collection('software_pages')
          .doc(_this.props.match.params.id)
          .get()
          .then(doc => {
            if (doc.exists) {
              let docData = doc.data();
              _this.setState({
                prodType: docData.prodType,
                prodName: docData.prodName,
                prodCategory: docData.prodCategory,
                prodPrice: docData.prodPrice,
                prodDevName: docData.prodDevName,
                prodDetails: docData.prodDetails,
                prodLink: docData.prodLink,
              });
            }
          })
          .catch(function (error) {
            console.log('Error getting document:', error);
          });
      } else {
        // TODO: Add to redirect page
      }
    });
  }

  handleFormSubmit(event) {
    event.preventDefault();

    // Firebase references stuff
    var softwarePagesRef = this.db.collection('software_pages');

    const form = event.currentTarget;
    let alertNeeded = false,
      alerts = [];

    // if(this.state.pagesLeft <= 0) {
    //     alertNeeded = true;
    //     alerts = alerts.concat('You have exceeded the maximum number of pages you can host.');
    //     this.setState({showAlert: true, alertText: alerts});
    //     return;
    // }

    if (form.checkValidity() === false) {
      console.log('Form not valid!');
      event.stopPropogation();
      return;
    }

    if (!this.validateURL(this.state.prodLink)) {
      alertNeeded = true;
      alerts = alerts.concat('Please enter a valid URL');
    } else {
      console.log('URL is valid');
    }

    if (alertNeeded) {
      this.setState({ showAlert: true, alertText: alerts });
      return;
    }

    let _this = this;
    let stateData = this.state;

    const ref = softwarePagesRef.doc(this.props.match.params.id);

    ref
      .update({
        prodType: stateData.prodType,
        prodCategory: stateData.prodCategory,
        prodPrice: stateData.prodPrice,
        prodDevName: stateData.prodDevName,
        prodDetails: stateData.prodDetails,
        prodLink: stateData.prodLink,
      })
      .then(result => {
        if (_this.state.updatePhoto === true) {
          console.log('We made it!');
          var photoRef = _this.storageRef.child(
            'product_images/' + this.props.match.params.id
          );
          var file = _this.state.files[0]; // use the Blob or File API
          photoRef
            .put(file)
            .then(function (snapshot) {
              // TODO: Update the indices in Algolia Search as well
              this.index
                .partialUpdateObject({
                  prodType: stateData.prodType,
                  prodCategory: stateData.prodCategory,
                  prodPrice: stateData.prodPrice,
                  prodDevName: stateData.prodDevName,
                  prodDetails: stateData.prodDetails,
                  prodLink: stateData.prodLink,
                  objectID: this.props.match.params.id,
                })
                .then(({ objectID }) => {
                  console.log(objectID);
                });
              _this.props.history.push('/my_account');
            })
            .catch(err => {
              console.log('File upload error: ', err);
            });
        }
      })
      .catch(err => console.log('Error: ', err));
  }

  validateURL(str) {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  }

  showAlert() {
    if (this.state.showAlert) {
      return (
        <Alert variant="danger">
          <Alert.Heading> Please fix the following problems: </Alert.Heading>
          <ul>
            {this.state.alertText.map(alertText => (
              <li> {alertText} </li>
            ))}
          </ul>
        </Alert>
      );
    } else {
      return <div></div>;
    }
  }

  // One validation function for all file types
  isValidFileType(fName, fType) {
    var extensionLists = {}; //Create an object for all extension lists
    extensionLists.video = ['m4v', 'avi', 'mpg', 'mp4', 'webm'];
    extensionLists.image = ['jpg', 'jpeg', 'png', 'JPG', 'PNG'];
    return extensionLists[fType].indexOf(fName.split('.').pop()) > -1;
  }

  handleImageUpload(evt) {
    evt.preventDefault();
    if (
      !this.isValidFileType(evt.target.files[0].name.toLowerCase(), 'image')
    ) {
      this.setState({
        showAlert: true,
        alertText: this.state.alertText.concat(
          'Please upload an image file of .jpg or .png'
        ),
      });
      return;
    }
    // If suitable imgage
    this.setState({ files: evt.target.files });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  handleToggle(e) {
    this.setState({ termsAgree: !this.state.termsAgree });
  }

  handleUploadPhotoToggle(e) {
    this.setState({ updatePhoto: !this.state.updatePhoto });
  }

  render() {
    return (
      <div className="container">
        <h3> Add a software page </h3>
        <this.showAlert />
        {/*<p> You have {this.state.pagesLeft} pages remaining. </p> */}
        <Form onSubmit={this.handleFormSubmit}>
          <Form.Group controlId="exampleForm.ControlSelect1">
            <Form.Control
              required
              name="prodType"
              value={this.state.prodType}
              onChange={this.handleChange}
              as="select"
            >
              <option>Software</option>
              <option>Game</option>
              <option>App</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formProductName">
            <Form.Control
              required
              disabled
              name="prodName"
              value={this.state.prodName}
              onChange={this.handleChange}
              type="name"
              placeholder="Name"
            />
          </Form.Group>
          <Form.Group controlId="formCategory">
            <Form.Control
              required
              name="prodCategory"
              value={this.state.prodCategory}
              onChange={this.handleChange}
              type="name"
              placeholder="Category - name your niche (i.e. comic book viewer)"
            />
          </Form.Group>

          <Form.Group controlId="formPrice">
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroupPrepend">$</InputGroup.Text>
              </InputGroup.Prepend>

              <Form.Control
                aria-describedby="inputGroupPrepend"
                required
                type="number"
                value={this.state.prodPrice}
                name="prodPrice"
                onChange={this.handleChange}
                placeholder="Price in USD ($). Enter 0 if it is free"
                step="0.01"
              />
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="formDeveloperName">
            <Form.Control
              required
              type="name"
              name="prodDevName"
              onChange={this.handleChange}
              value={this.state.prodDevName}
              placeholder="Developer Name"
            />
          </Form.Group>

          <Form.Group controlId="formCheckbox">
            <Form.Check
              type="checkbox"
              name="updatePhoto"
              onChange={this.handleUploadPhotoToggle}
              label="Update the photo"
              checked={this.state.updatePhoto}
            />
          </Form.Group>

          <div class="custom-file" style={{ margin: '0px 0px 15px 0px' }}>
            <form onSubmit={this.handleImageUpload}>
              <input
                onChange={this.handleImageUpload}
                type="file"
                id="files"
                name="files[]"
                class="custom-file-input"
              />
              <label class="custom-file-label" for="files">
                If you want to change the image, upload a new product logo 150px
                by 150 px
              </label>
              <br />
            </form>
          </div>

          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Control
              required
              as="textarea"
              rows="3"
              value={this.state.prodDetails}
              name="prodDetails"
              onChange={this.handleChange}
              placeholder="Enter details about the app: why it is useful and what it does"
            />
          </Form.Group>

          <Form.Group controlId="formBasicName">
            <Form.Control
              required
              type="link"
              name="prodLink"
              value={this.state.prodLink}
              onChange={this.handleChange}
              placeholder="Enter a link to the product. It must be a valid, public URL, and it must have been created by the developer."
            />
          </Form.Group>

          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              required
              type="checkbox"
              label="I agree that I am submiting accurate information. Including information that does not confirm with the policies* may result in my account being suspended or banned. This may include putting links to irrelevant content"
            />
          </Form.Group>
          <ButtonStrap
            variant="primary"
            type="submit"
            style={{ margin: '0px 0px 75px 0px' }}
          >
            Save
          </ButtonStrap>
        </Form>
      </div>
    );
  }
}

export default EditSoftwarePage;
